export default {
  'servicesOverview.tag': '专业服务',
  'servicesOverview.title': '我们的服务',
  'servicesOverview.desc':
    '在全球主要司法管辖区提供金融及企业咨询服务，涵盖海外基金设立、金融牌照申请、海外公司设立与公司并购等全流程支持。',
  'servicesOverview.cta': '了解详情',

  'servicesOverview.lines.overseasFund.label': '海外基金设立',
  'servicesOverview.lines.overseasFund.desc':
    '协助客户在爱尔兰、卢森堡、马耳他等欧洲主要司法管辖区设立境外投资基金，涵盖结构规划、监管申报及持续合规。',
  'servicesOverview.lines.overseasFund.tags.0': 'UCITS / AIF',
  'servicesOverview.lines.overseasFund.tags.1': '欧盟护照',
  'servicesOverview.lines.overseasFund.tags.2': '持续合规',

  'servicesOverview.lines.financialLicensing.label': '金融牌照申请',
  'servicesOverview.lines.financialLicensing.desc':
    '为英国、爱尔兰、立陶宛、瑞士等多个司法管辖区申请金融服务牌照提供全程支持，包括电子银行、外汇经纪、支付及加密资产等牌照类型。',
  'servicesOverview.lines.financialLicensing.tags.0': 'EMI / 支付',
  'servicesOverview.lines.financialLicensing.tags.1': '外汇经纪',
  'servicesOverview.lines.financialLicensing.tags.2': '加密资产',

  'servicesOverview.lines.overseasCompany.label': '海外公司设立',
  'servicesOverview.lines.overseasCompany.desc':
    '为英国、爱尔兰、葡萄牙、立陶宛、马耳他等司法管辖区注册公司提供专业指导，包括注册地址、银行开户及持续秘书服务。',
  'servicesOverview.lines.overseasCompany.tags.0': '欧洲注册',
  'servicesOverview.lines.overseasCompany.tags.1': '离岸架构',
  'servicesOverview.lines.overseasCompany.tags.2': '秘书服务',

  'servicesOverview.lines.mergersAcquisitions.label': '公司并购',
  'servicesOverview.lines.mergersAcquisitions.desc':
    '为跨境并购交易提供战略咨询，包括持牌公司收购、尽职调查协调及并购后整合支持。',
  'servicesOverview.lines.mergersAcquisitions.tags.0': '持牌收购',
  'servicesOverview.lines.mergersAcquisitions.tags.1': '尽职调查',
  'servicesOverview.lines.mergersAcquisitions.tags.2': '并购整合',

  'services.detail.overseas-fund-setup.title': '海外基金设立',
  'services.detail.overseas-fund-setup.summary':
    '协助客户在爱尔兰、卢森堡、马耳他等欧洲主要司法管辖区设立境外投资基金，涵盖结构规划、监管申报及持续合规。',
  'services.detail.overseas-fund-setup.content': `## 基金类型

在欧盟（含英国），主要有两大基金形式：

- **UCITS（可转让证券集合投资型基金）** — 主要针对零售型投资人，流动性相对较强，通常为开放式基金。可投资股票、债券等可转让证券。符合 UCITS 要求的基金可享受欧盟护照制度，在欧盟市场内销售。
- **另类投资型基金（AIF）** — 主要针对有投资经验的专业型投资人。类型包括不动产基金、私募股权基金、对冲基金、另类投资组合型基金、商品基金、基础建设基金及不在 UCITS 范围内的债权基金等。符合 AIFMD 要求的基金同样可受益于欧盟护照制度。

## 设立基金时应考虑的因素

- 目标投资人及基金规模
- 投资策略、资产类型及基金注册地
- 市场分销策略
- 设立成本及后续维护成本
- 选择合适的基金类型，以及单一基金或伞形基金的选择
- 潜在的税收优惠
- 基金运营生态圈

## 所需金融服务合作方及费用

- **本地董事** — 须有相关从业经验，费用因注册地不同而异
- **持牌基金管理人（AIFM/Manco）** — 通常为净资产的 0.3% 至 1%
- **基金托管行（Depositary）** — 通常为净资产的 0.05% 至 0.10%，可能设有年度最低托管费
- **基金行政管理机构（Fund Administrator）** — 通常为净资产的 0.10% 至 0.30%
- **基金审计师** — 根据规模及复杂程度收取
- **基金法律顾问** — 根据运营需求收取

## 我们提供的服务

- 根据客户商业模式及计划投资规模、资产类型建议合适的基金形式
- 在当地为客户注册基金公司（私人有限公司、信托公司或开放式投资公司等）
- 帮助客户建立专业管理团队，包括持牌人、合规官及董事成员
- 协助律师撰写基金说明书、股权认购书、子基金说明书、运营企划案及财务预算等
- 介绍符合监管要求的金融服务方，并代表客户审核相关合同
- 代表客户向监管机构递交基金授权申请
- 审核期间代表客户回复监管机构问询或出席面试

## 可协助申办的监管机构

- 英国金融行为监管局（FCA）
- 爱尔兰中央银行
- 立陶宛中央银行
- 葡萄牙中央银行`,

  'services.detail.financial-licensing.title': '金融牌照申请',
  'services.detail.financial-licensing.summary':
    '为客户在英国、爱尔兰、立陶宛、瑞士等多个司法管辖区申请金融服务牌照提供全程支持，包括电子银行牌照、外汇经纪商牌照、支付牌照、虚拟货币交易牌照及 ICO 牌照。',
  'services.detail.financial-licensing.content': `## 牌照类型

### 外汇经纪商牌照

英国外汇交易牌照主要分为三类：

- **做市商牌照（MM）** — 为投资者提供独立买卖交易平台，可持有客户资金及自营交易。最低注册资金：73 万欧元。
- **STP 牌照（撮合配对交易）** — 作为中间商撮合交易，可持有客户资金但不能自营交易。最低注册资金：12.5 万欧元。
- **推广券商牌照** — 为客户介绍持牌公司，不可持有客户资金。最低注册资金：5 万欧元。

### 电子银行牌照（EMI）

电子银行牌照除可提供支付牌照的全部业务外，还可提供：开设支付账户、发行储蓄卡/信用卡、消费贷款、区块链稳定电子货币发行及 P2P 服务（附加授权）。最低注册资金：35 万欧元。审批时间：通常 4-5 个月。

### 支付牌照

主要为企业及个人提供国际支付及转账服务，包括支付账户、第三方支付、收款工具及汇款等。最低注册资金：汇款 2 万欧元，商家收款 5 万欧元，支付账户 12.5 万欧元。审批时间：6-12 个月。

### 信托公司牌照（泽西岛）

两种形式：**管理信托公司**（依附已持牌公司，申请难度较低）或**信托牌照全牌公司**（可管理全球范围内的信托，申请较复杂）。审批时间：6-8 个月。需在泽西岛设有完整运营，至少 5 名董事（多数须为本地居民），合规官及反洗钱官须分设。

### 虚拟货币/加密资产牌照

协助客户在波兰、BVI、开曼群岛、马耳他等多个司法管辖区申请加密货币牌照，同时支持欧盟 MiCAR CASP 加密资产服务商牌照申请。

### 消费信贷牌照（英国）

分为有限许可（消费者租赁、附属信贷经纪）及全牌照（所有信贷类型、债务管理、P2P 借贷）。无最低资本要求（债务管理除外）。通过 FCA Connect 在线系统申请。

### 消费信贷牌照（立陶宛 & 爱沙尼亚）

立陶宛：材料齐全后 2-3 个月可获批；可与 EMI/支付牌照结合覆盖整个欧盟。爱沙尼亚：由 Finantsinspektsioon 颁发，无到期日，涵盖债权人及抵押债权人两类；审批时间 6-8 个月。

## 我们提供的服务

- 根据商业模式建议最合适的牌照类型
- 当地公司注册
- 帮助准备预申请材料及问卷，协助或代表客户出席预申请面试
- 撰写申请表、商业计划书、运营企划案及财务预算
- 建立专业管理团队，包括持牌人、合规官及董事成员
- 协助 IT 系统开发
- 递交后代表客户回复监管机构问询

## 可协助申办的监管机构

- 英国 FCA
- 爱尔兰中央银行
- 立陶宛中央银行
- 葡萄牙中央银行
- 瑞士 FINMA / SRO
- 泽西岛金融服务委员会（JFSC）
- 欧盟及离岸各司法管辖区监管机构`,

  'services.detail.overseas-company.title': '海外公司设立',
  'services.detail.overseas-company.summary':
    '为客户在英国、爱尔兰、葡萄牙、立陶宛、马耳他等司法管辖区注册公司提供专业指导，包括注册地址、银行开户及持续秘书服务。',
  'services.detail.overseas-company.content': `## 主要注册地

我们可协助客户在以下司法管辖区注册公司：

- **欧洲：**爱尔兰、英国、葡萄牙、立陶宛、马耳他、瑞士、荷兰、西班牙、匈牙利、马恩岛
- **离岸地区：**BVI、开曼群岛、多米尼加、格林纳达、圣卢西亚、毛里求斯（GBC1）
- **其他：**尼日利亚、塞尔维亚等

## 为何选择海外注册？

- 获取特定金融监管资质及欧盟护照权利
- 税务优化与资产保护
- 提升国际公信力及市场准入
- 用于投资或知识产权的控股架构

## 我们提供的服务

- 公司名称搜索及预留
- 准备并提交所有注册文件
- 提供注册地址
- 介绍本地董事及公司秘书
- 银行开户协助
- 持续秘书及合规服务
- 协助满足当地实质性要求`,

  'services.detail.mergers-acquisitions.title': '公司并购',
  'services.detail.mergers-acquisitions.summary':
    '为跨境并购交易提供战略咨询，包括持牌公司收购、尽职调查协调及并购后整合支持。',
  'services.detail.mergers-acquisitions.content': `## 并购咨询服务

为跨境并购及持牌实体交易提供全程支持，覆盖欧洲及全球主要司法管辖区。

## 可供收购的持牌资产

我们维护着一批可供收购的持牌实体，包括：

- 持牌投资公司（如卢森堡 MiFID 持牌公司）
- EMI 及支付机构牌照持有人（荷兰、波兰）
- 全牌照银行（科摩罗安儒昂、波多黎各）
- 持有支付牌照的加密货币交易所（波兰）
- 葡萄牙及其他欧盟银行牌照

## 我们的服务流程

- 初步筛选及目标识别
- 初步尽职调查及监管状态审查
- 架构建议及交易谈判支持
- 协调法律、合规及财务尽职调查
- 监管变更控制申报及审批支持
- 并购后整合规划

## 为何收购持牌实体？

- 相比从零申请牌照，市场进入速度更快
- 即刻具备运营能力
- 已有监管关系及合规基础设施`,

  'seo.services.title': '服务',
  'seo.services.desc':
    '海外基金设立、金融牌照申请、海外公司设立与公司并购等跨境金融与企业咨询服务。',
  'seo.services.keywords':
    'GEEL TEC, 服务, 海外基金, 金融牌照, 海外公司设立, 公司并购, 跨境咨询',

  'seo.services.overseas-fund-setup.title': '海外基金设立',
  'seo.services.overseas-fund-setup.desc':
    '爱尔兰、卢森堡、马耳他等地境外基金设立，涵盖 UCITS/AIF 结构规划、监管申报与持续合规。',
  'seo.services.overseas-fund-setup.keywords':
    'GEEL TEC, 海外基金, UCITS, AIF, 基金设立, 欧盟基金, 基金合规',

  'seo.services.financial-licensing.title': '金融牌照申请',
  'seo.services.financial-licensing.desc':
    '英国、爱尔兰、立陶宛、瑞士等地 EMI、支付、外汇经纪与加密资产等金融牌照申请全程支持。',
  'seo.services.financial-licensing.keywords':
    'GEEL TEC, 金融牌照, EMI, 支付牌照, 外汇牌照, 加密资产牌照, FCA',

  'seo.services.overseas-company.title': '海外公司设立',
  'seo.services.overseas-company.desc':
    '欧洲及离岸司法管辖区公司注册、秘书服务、银行开户与实质性合规支持。',
  'seo.services.overseas-company.keywords':
    'GEEL TEC, 海外公司, 公司注册, 离岸公司, 秘书服务, 银行开户',

  'seo.services.mergers-acquisitions.title': '公司并购',
  'seo.services.mergers-acquisitions.desc':
    '跨境并购与持牌实体收购，涵盖目标筛选、尽职调查、监管申报与并购后整合。',
  'seo.services.mergers-acquisitions.keywords':
    'GEEL TEC, 公司并购, 持牌收购, 尽职调查, 跨境并购, 并购整合',
};
